import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue'
import LazyImage from './LazyImage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LazyVideo',
  props: {
    src: null,
    thumbnailSrc: null,
    parentContainer: { default: null }
  },
  emits: ["viewportIntersect"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'viewportIntersect'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { src: string, thumbnailSrc: string, parentContainer: HTMLElement | null };





const showThumbnail = ref(true)
const vid = ref<HTMLVideoElement | null>(null)
let playPromise: Promise<void> | null = null
const resourceAvailable = ref(true)

onMounted(() => {
  if (vid.value) {
    const video = vid.value
    new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // video is entering the viewport
            emits('viewportIntersect')
          } else if (video.src !== '') {
            // unload the video when it leaves the viewport
            if (playPromise) {
              playPromise.then(() => {
                unloadVideo()
              })
            } else {
              unloadVideo()
            }
          }
        })
      },
      {
        // Observe intersection with the viewport
        root: props.parentContainer,
        // We may want to adjust this to allow images to start loading slightly earlier than being in the viewport
        rootMargin: '300px 0px 300px 0px'
      }
    ).observe(vid.value)
  }
})

const unloadVideo = () => {
  if (vid.value && vid.value.src !== '' && resourceAvailable.value) {
    showThumbnail.value = true
    vid.value.pause()
    // src attribute must be a valid non-empty string, so must be removed to unload the video
    vid.value.removeAttribute('src')
    vid.value.load()
  }
}

const toggleVideoPlay = () => {
  if (vid.value) {
    if (vid.value.src === '') {
      vid.value.src = props.src
      vid.value.load()
    }
    vid.value.currentTime = 0

    playPromise = vid.value.play()
      .then(() => { showThumbnail.value = false })
      .catch(() => { resourceAvailable.value = false })
  }
}

const toggleVideoStop = () => {
  if (vid.value && resourceAvailable.value) {
    showThumbnail.value = true
    // Play function is asynchronous, and will throw error when interrupted
    if (playPromise) {
      playPromise.then(() => {
        if (vid.value) {
          vid.value.pause()
        }
      })
    }
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "lazy-video",
    onMouseover: toggleVideoPlay,
    onMouseleave: toggleVideoStop
  }, [
    _createVNode(LazyImage, {
      class: _normalizeClass(['lazy-video__thumbnail', {'lazy-video__thumbnail--hidden': !showThumbnail.value}]),
      src: __props.thumbnailSrc,
      "parent-container": __props.parentContainer
    }, null, 8, ["class", "src", "parent-container"]),
    _createElementVNode("video", {
      class: "lazy-video__video",
      ref_key: "vid",
      ref: vid,
      muted: "",
      loop: "",
      preload: "metadata"
    }, null, 512)
  ], 32))
}
}

})